import { captureException } from '@sentry/browser';
import { getErrorMsg, logger } from 'lib/logger';
import { cancel, put } from 'redux-saga/effects';

export function* loggerSaga({ error, action }: { error?: any; action?: any }) {
    logger.error(getErrorMsg(error), error);
    captureException(error);

    if (action) {
        yield put(action);
    }

    yield cancel();
}
